import { Space, Divider, Select, Button, Input, Table, Popconfirm,Typography,Checkbox, Tooltip, Modal, Form,message, Image, Result, Spin } from 'antd';
import { DeleteOutlined, CheckOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, getPriorityCount } from '../../globalFunctions/GlobalFunctions';
import constants from '../../constants/constants';
import WebLinks from '../../api/WebLinks';
import APIUtils from '../../api/APIUtils';
import { CommonContext } from '../../Context';

const { Search } = Input;
const { Option } = Select

const JobBoostSupplierContract = () => {
  //Variable declaration
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [YourJobsData, setYourJobsData] = useState([]);
  const [supplierLogoUrl, setSupplierLogoUrl] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [searchedValue, setSearchedValue] = useState("");
  const [jobsCount, setJobsCount] = useState(0);
  const [sortedValue, setSorterValue] = useState({
    columnKey: "",
    order: 'descend'
  });
  const [isLoading, setIsLoading] = useState(false);
  const { supplierId } = useParams();
  const [priorityList,setPriorityList]=useState([]);
  const [priorityColorCode,setPriorityColorCode]=useState([]);
  const [priorityCheck,setPriorityCheck]=useState("f");
  const [selectedJobList,setSelectedJobList] = useState([]);
  const [termsChecked, setTermsChecked] = useState(false);
  const [showBoostProductBuy, setShowBoostProductBuy] = useState(false);
  const [currencValue,setCurrencyValue]=useState();
  const [selectedTotal,setSelectedTotal]=useState(0);
  const [reload,setReload]=useState(false);
  const [bookLoader,setBookLoader]=useState(false);
  
	const boostJobsBuyColumns = [
		{
			title: 'Job',
			dataIndex: 'title',
			key: 'title',
			render: (text,record) =>
			(<>
				<p className='whitespace-nowrap'>{text}</p>
				<span className='font-semibold text-gray-400'>{record.name}</span></>
			)
		},
		{
			title: 'Location',
			dataIndex: 'place',
			key: 'place',
		},
		{
			title: 'Days',
			dataIndex: 'postingDurationDays',
			key: 'postingDurationDays',
			render: (text,record) =>
			(
				record?.customercontracts?.length>0?
				<span className='whitespace-nowrap'>-</span>:
				<span className='whitespace-nowrap'>{text} Days</span>
			)
		},
		{
			title: 'Price',
			dataIndex: 'price_agreement',
			key: 'price_agreement',
			render: (text,record) =>
			(
				record?.customercontracts?.length>0?
				<span className='whitespace-nowrap'>{record?.priceCurrencySymbol} 0</span>:
				<span className='whitespace-nowrap'>{record?.priceCurrencySymbol} {text}</span>
			)
		},
		{
			title: 'Actions',
			key: 'action',
			align: 'center',
			render: (_, record) =>
				<Tooltip title="Delete" placement='bottom'>
					<Popconfirm title="Sure you want to delete?" onConfirm={()=>DeleteBuyProduct(record)} placement="left">
						<Button icon={<DeleteOutlined />} type="link" size='large' />
					</Popconfirm>
				</Tooltip>
		}
	];

  //Function on page load
  useEffect(() => {
    getBuyerPrioritylist();
    yourJobsListFetch(currentPage, pageSize, "", sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
  }, []);
	useEffect(() => {
		
	}, [reload]);
  //Fetch the jobs upload history for the last 30 days 
  const yourJobsListFetch = async (currentPage, pazeSize, searchValue, sortColumn, isSortDesc, priorityLevel) => {
    setIsLoading(true);
    sortColumn = sortColumn !== undefined ? sortColumn : ""
    let url = WebLinks.GetSupplierContractBoost + buyerId +"&supplierId="+supplierId+ "&limit=" + pazeSize + "&pageNo=" + currentPage + "&search=" + searchValue + "&sortBy=" + sortColumn + "&sortDesc=" + isSortDesc
    if (priorityLevel && priorityLevel !== "-1") {
      url += "&priorityLevel=" + priorityLevel;
    }
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj ) {
      setYourJobsData(response?.resultObj?.data);
      setJobsCount(response?.resultObj?.getCount);
      setSupplierLogoUrl(response?.resultObj?.supplierUrl);
      if(response?.resultObj?.data){
        setCurrencyValue(response?.resultObj?.data[0]?.priceCurrencySymbol||"")
      }
    } else {
      message.error(response?.resultObj?.message);
    }
    setIsLoading(false)
  };

  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setPriorityList(response.resultObj.data);
      let temppriorityColorCode=[];
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
      response?.resultObj?.data.forEach(element => {
        let priorityObj={
          value:element.priorityLevel.toString(),
          colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
          customName:element.customName,
          prioritycount:getPriorityCount(element.priorityLevel,response?.resultObj?.priorityCount)
        }
        temppriorityColorCode.push(priorityObj);
        setPriorityColorCode(temppriorityColorCode);
      });
    } else {
      setPriorityList([]);
      setPriorityColorCode([]);
      message.error(response?.resultObj?.message);
    }
  };

  //Function to get the Priority Level to change multiple jobs.
  const onSelectRow = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedJobList(selectedRows);
    let total=0;
		selectedRows.map((item)=>{
			total=total+item?.price_agreement||0
		})
		setSelectedTotal(total);
  };

  //Buy Products summary
	const BuyProductsSummary = () => {
		return (
			<>
				<Table.Summary.Row className='bg-teal-50'>
					<Table.Summary.Cell index={0}><strong>Total</strong></Table.Summary.Cell>
					<Table.Summary.Cell index={1} className='text-center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={2} className='text-center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={3}></Table.Summary.Cell>
					<Table.Summary.Cell index={4}>{currencValue} {selectedTotal}</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		)
	};

  //Open  buy modal
	const openBuyModal = () => {
		setShowBoostProductBuy(true);
	}

	//Close buy modal
	const handleBuyCancel = () => {
		setShowBoostProductBuy(false);
	};

  //Delete selected product
	const DeleteBuyProduct=(record)=>{
		let tempDeleteArray=selectedJobList;
		tempDeleteArray=tempDeleteArray.filter((item)=>item.id!==record.id)
    let tempRowKeys= selectedRowKeys.filter((item)=>item!==record.id)
		let total=0;
		tempDeleteArray.map((item)=>{
			total=total+item?.price_agreement||0
		})
		setSelectedTotal(total);
    setSelectedJobList(tempDeleteArray);
    setSelectedRowKeys(tempRowKeys)
    setReload(!reload);
	}

  //Remove all selected products
  const removeSelectedAll=()=>{
    setSelectedJobList([]);
    handleBuyCancel();
    setSelectedRowKeys([])
    setSelectedTotal(0);
    setReload(!reload);
  }

  //Book Jobs function
	const BookJobsNow = async () => {
    setBookLoader(true);
    let payload = null;
    payload = {
        selectedJobList
    };
    const jobBookResponse = await APIUtils.apiCall("POST", WebLinks.AddSelectedRecommendedJobs + buyerId, JSON.stringify(selectedJobList));
    if (!jobBookResponse.isCatch) {
      setBookLoader(false);
        const modal = Modal.info({
            width: 650,
            icon: null,
            footer: null,
            content: (
                <Result
                    status="success"
                    title="Thanks for placing this order."
                    subTitle={
                        <div>
                            <p>We are now processing it.</p>
                            <p>You can view the status of the order in the Boost Orders page.</p>
                            <p>All jobs included in this order have been removed from your shopping basket.</p>
                            <p>If you wish to Boost them to other boards you can add them back in and create an additional order.</p>
                        </div>
                    }
                    extra={
                        <Button type="primary" onClick={() => {
                            modal.destroy();
                            handleBuyCancel();
                            yourJobsListFetch(1, 100, "", sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
                            setCurrentPage(1);
                            setPageSize(100);
                        }}>
                            OK
                        </Button>
                    }
                />
            )
        });
        if(jobBookResponse?.resultObj?.jobIdsNotPresentInBoostJobBasket && jobBookResponse?.resultObj?.jobIdsNotPresentInBoostJobBasket?.length>0){
          UpdateBoostBasket(jobBookResponse.resultObj.jobIdsNotPresentInBoostJobBasket);
        }
    } else {
      setBookLoader(false);
      message.error(jobBookResponse.resultObj.message);
    }
  };


  //Function to Update boost basket
  const UpdateBoostBasket = async (selectedIds) => {
    let updateBoostPayload;
    updateBoostPayload={
      buyerId:buyerId,
      jobId:selectedIds,
      UpdatedByBuyerId:Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)
    }
    const boostJobResponse = await APIUtils.apiCall("POST", WebLinks.InsertJobBoostBasket , JSON.stringify(updateBoostPayload));
    if (boostJobResponse.isCatch) {
      message.error(boostJobResponse.resultObj.message);
    } else {
      // message.success(boostJobResponse.resultObj.message);
      UpdateBoostSection(updateBoostPayload)
    }
  }

  const UpdateBoostSection=async(Payload)=>{
    const boostJobResponse = await APIUtils.apiCall("PUT", WebLinks.InsertJobBoostBasketSection , JSON.stringify(Payload));
    if (boostJobResponse.isCatch) {
      message.error(boostJobResponse.resultObj.message);
    }
  }
  //Function on change of application table
  const onChangeJobTable = (pagination, filters, sorter) => {
    if (pagination) {
      if (pageSize !== pagination.pageSize) {
        setCurrentPage(1);
      } else {
        setCurrentPage(pagination?.current);
      }
      setPageSize(pagination?.pageSize);
      if (sorter) {
        setSorterValue(sorter);
        yourJobsListFetch(pagination?.current, pagination?.pageSize, searchedValue, sorter.order ? sorter.columnKey : "", sorter.order === "ascend" ? false : true);
      } else {
        yourJobsListFetch(pagination?.current, pagination?.pageSize, searchedValue, sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
      }
    }
  };

  //Function on search
  const searchJob = (searchText) => {
    yourJobsListFetch(1, 100, searchText, sortedValue.columnKey, sortedValue.order === "ascend" ? false : true);
    setCurrentPage(1);
    setPageSize(25);
  }

  const filterPriority = (value) => {
    yourJobsListFetch(1, 100, searchedValue, sortedValue.columnKey, sortedValue.order === "ascend" ? false : true, value);
  }

  // Table columns
  const yourJobsColumns = [
    {
      title: 'Priority',
      key: 'priority',
      dataIndex: 'priority',
      align: 'center',
      width: '5%',
      sorter: (a, b) => a.priority - b.priority,
      render: (_, record) => (
        <Select
          //onChange={(e) => singlePriorityChange(e, record.id)}
          value={record.priority}
          className='w-14'
          options={priorityCheck==="t"?constants.PriorityConstantList2:constants.PriorityConstantList1}
        />
      ),
    },
    {
      title: 'Job Title',
      dataIndex: 'title',
      key: 'jobTitle',
      width: '20%',
      sorter: (a, b) => a.title - b.title,
    },
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
      width: '10%',
      sorter: (a, b) => a.reference - b.reference,
    },
    {
      title: 'Location',
      dataIndex: 'place',
      key: 'place',
      width: '35%',
      sorter: (a, b) => a.place - b.place,
    },
    {
      title: 'Occupation',
      dataIndex: 'occupation',
      key: 'occupation',
      width: '15%',
      sorter: (a, b) => a.occupation - b.occupation,
    },
    Table.SELECTION_COLUMN,
    {
      title: 'Boost',
      dataIndex: 'boost',
      key: 'Boost',
      width: '15%',
      render: (_, record) => (
        record.boosted===true?
        <span>Boosted</span>:
        <span>{record?.limitType==="credits"?record?.limitTotal-record.limitUsed+"/"+record?.limitTotal+"Credits Remaining":"No Contract Detected"}</span>
      ),
    },
  ];
  // Table end

  return (
    <div>
      <div className="flex justify-end mb-3 text-xs">
       <Space wrap>
          <label>
          <strong>{constants.PriorityLevels}</strong>
          </label>
          {priorityColorCode?.map((item=>{
            return(
              <Space>
              <div className={item.colorValue}></div>
              <span>{item.customName} [{item.prioritycount}]</span>
            </Space>
            )
          }))}
         </Space>
      </div>
      <div className="flex flex-wrap justify-between items-center gap-1">
        <Space>
          <div className="uppercase font-bold text-xl">Jobs In Feed : </div> <Image src={supplierLogoUrl} preview={false} width={100} />
        </Space>
      </div>
      <Divider className="my-3" />
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Select
          onChange={filterPriority}
          defaultValue={"-1"}
          placeholder="Please select"
          className="w-[65vw] md:w-60"
        >
          <Option value="-1">
            <Space>
              Priority Filter - Show All
            </Space>
          </Option>
          {priorityColorCode?.map((item=>{
                return(
              <Option value={item.value}>
                   <Space>
                     <div className={item.colorValue}></div>
                     {item.customName}
                   </Space>             
              </Option>
                )
          }))}
        </Select>  

        <Search
          placeholder="Search"
          allowClear
          onSearch={(e) => searchJob(e)}
          onChange={(e) => { searchJob(e.target.value); setSearchedValue(e.target.value) }}
          enterButton
          className="w-full md:w-60"
        />
        <Button icon={<CheckOutlined />} onClick={()=>openBuyModal()}>Boost Selected</Button>
      </div>
      <div className="overflow-x-auto">
        <Table
        loading={isLoading}
          size='small'
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
           // hideSelectAll:true,
						onChange:onSelectRow,
          }}
          rowKey="id"
          columns={yourJobsColumns}
          dataSource={YourJobsData}
          onChange={onChangeJobTable}
          pagination={{
            total: jobsCount,
            showSizeChanger: true,
            pageSizeOptions: ["50", "100", "200", "500"],
            defaultPageSize: 100,
            current: currentPage,
          }}
          footer={() => YourJobsData?
             'Showing ' + ((currentPage - 1) * pageSize + 1) + ' to ' + ((currentPage - 1) * pageSize + YourJobsData?.length) + ' of ' + jobsCount + ' entries'
            : 'Showing 0 entries'
          }
        />
      </div>
      <Modal
						title={"BOOST ORDER"}
						open={showBoostProductBuy}
						onCancel={handleBuyCancel}
						style={{ top: 20 }}
						width={1000}
						footer={[]}
						destroyOnClose={true}
					>
            <Spin spinning={bookLoader}>
              <div className='text-right mt-3'>
                <Button className='mr-3' icon={<DeleteOutlined />} onClick={() => removeSelectedAll()}>Remove All</Button>
              </div>
              <Table
                //loading={isLoading}
                size='small'
                columns={boostJobsBuyColumns}
                dataSource={selectedJobList}
                pagination={false}
                showHeader={false}
                summary={() => BuyProductsSummary()}
              />
              <div className='mt-3'>
                <Checkbox onChange={(e) => { setTermsChecked(e.target.checked) }}> 
                  {constants.BOOST_JOB_AD_TERMS_MSG}
                  <Typography.Link onClick={() => window.open('/terms-and-conditions', '_blank')}>Terms and Conditions.</Typography.Link>
                </Checkbox>
              </div>
              <div className='font-semibold mt-3'>{constants.BOOST_JOB_AD_BUY_TEXT}</div>
              <div className='text-right mt-3'>
                <Button className='mr-3' icon={<ArrowLeftOutlined />} onClick={() => handleBuyCancel()}>Change Selection</Button>
                <Button type="primary" disabled={!termsChecked } icon={<CheckOutlined />} onClick={()=>BookJobsNow()}>Book Now</Button>
              </div>
            </Spin>
					</Modal>
    </div>
  );
};

export default JobBoostSupplierContract;